// Real component photos (public/robot-lab/parts) used by the 15 open labs.
export const partImg = (k) => `/robot-lab/parts/${k}.webp`;

export const PARTS = {
  frame: ["Carbon-fibre X frame", "250 mm · 3 mm arms", "Holds every part rigid and light"],
  motor: ["Brushless (BLDC) motor", "2205 · 2300 KV", "Spins the propeller to create lift"],
  props: ["Propellers", "5-inch · CW + CCW pair", "Push air down to lift the drone"],
  fc: ["Flight controller", "F4 board · gyro + accelerometer", "The brain that keeps it level"],
  pcb: ["ESC / power board", "4-in-1 · 35 A", "Controls each motor's speed"],
  lipo: ["LiPo battery", "4S 1500 mAh · XT60", "Rechargeable power pack"],
  tx: ["Radio transmitter", "2.4 GHz · 8 channels", "Your sticks for pitch, roll, yaw, throttle"],
  goggles: ["FPV goggles", "5.8 GHz video link", "See live from the drone's camera"],
  fpvdrone: ["FPV racing quad", "Freestyle 5-inch build", "A complete race-ready drone"],
  gimbal: ["3-axis camera gimbal", "Brushless · ±0.02° accuracy", "Keeps the camera steady"],
  gimbal2: ["Gimbal stabiliser rig", "Pan · tilt · roll motors", "Cancels shake on each axis"],
  servo: ["Smart servo modules", "Robot joints with feedback", "Rotate to an exact angle"],
  humanoid: ["Humanoid robot", "Full-body research robot", "Walks, waves and interacts"],
  arduino: ["Arduino Uno", "ATmega328P · 14 I/O pins", "Microcontroller that runs your code"],
  sensorkit: ["Sensor & relay kit", "Arduino + relay + sensors", "Reads the world and switches loads"],
  rpi: ["Raspberry Pi 4", "Quad-core · Wi-Fi · camera port", "Mini computer for vision and AI"],
  ultrasonic: ["Ultrasonic sensor", "HC-SR04 · 2–400 cm", "Measures distance with sound echoes"],
  cctv: ["Security camera", "1080p · night vision", "Watches the patrol area"],
  gripper: ["Robot gripper arms", "Pick-and-place end effectors", "Grip, lift and release objects"],
  arm: ["6-axis robotic arm", "Industrial arm model", "Reaches any point in its workspace"],
  solar: ["Solar panel cells", "Monocrystalline", "Turn sunlight into electricity"],
  homesensors: ["Smart home sensors", "Door, motion & temp sensors", "Tell the hub what's happening"],
  speaker: ["Smart speaker", "Far-field microphones", "Hears and answers voice commands"],
  homepod: ["Voice assistant hub", "Wi-Fi + Bluetooth", "Runs scenes by voice"],
  bulb: ["Smart LED bulb", "9 W · Wi-Fi · dimmable", "Turns on, off and dims from the app"],
  lightapp: ["Smart Hub app", "LuxeRay control app", "Controls every device from a phone"],
  doorlock: ["Smart door lock", "App + PIN unlock", "Lets guests in without a key"],
  vacuum: ["Robot vacuum base", "LiDAR navigation", "Maps the room and cleans it"],
  rocket: ["Model rocket", "Solid motor · recovery chute", "Carries the CanSat to altitude"],
  parachute: ["Recovery parachute", "Ripstop nylon canopy", "Slows the descent for a safe landing"],
  satellite: ["Satellite in orbit", "Low-Earth orbit ~500 km", "Real mission your CubeSat copies"],
  chip: ["Microchip / IMU module", "Accelerometer + gyro", "Senses tilt and motion"],
  radio: ["Radio + antenna", "UHF / VHF telemetry", "Talks to the ground station"],
  bench: ["Electronics test bench", "Breadboard + multimeter", "Where every build is tested"],
};

export const LAB_PARTS = {
  "drone-assembly": ["frame", "motor", "pcb", "fc", "tx", "lipo", "props"],
  "quad-flight-training": ["tx", "fc", "motor", "props", "lipo", "chip"],
  "hexacopter-build": ["frame", "motor", "fc", "chip", "lipo", "props"],
  "fpv-racing": ["fpvdrone", "goggles", "tx", "motor", "lipo", "props"],
  "humanoid-assembly": ["humanoid", "servo", "arduino", "lipo", "cctv", "chip"],
  "housemaid-robot": ["vacuum", "ultrasonic", "rpi", "servo", "gripper", "lipo"],
  "security-robot": ["cctv", "rpi", "ultrasonic", "homesensors", "radio", "lipo"],
  "luxeray-home-15": ["lightapp", "bulb", "homesensors", "doorlock", "speaker", "sensorkit"],
  "luxeray-hotel-25": ["doorlock", "lightapp", "bulb", "homesensors", "homepod", "sensorkit"],
  "cansat-launch": ["rocket", "parachute", "arduino", "chip", "radio", "lipo"],
  "cubesat-assembly": ["satellite", "solar", "rpi", "pcb", "radio", "lipo"],
  "arm-pick-place": ["arm", "gripper", "servo", "arduino", "sensorkit", "bench"],
  "voice-home": ["speaker", "homepod", "bulb", "lightapp", "sensorkit", "homesensors"],
  "gimbal-stabilization": ["gimbal", "gimbal2", "chip", "motor", "fc", "lipo"],
  "aerospace-intro": ["rocket", "satellite", "solar", "radio", "chip", "parachute"],
};

// Real photo for each assembly-kit part (structural shells stay as clean 3D shapes).
export const KIT_PHOTOS = {
  quad: { motors: "motor", esc: "pcb", fc: "fc", rx: "chip", battery: "lipo" },
  hexa: { motors: "motor", fc: "fc", gps: "chip", battery: "lipo" },
  humanoid: { ctrl: "arduino", battery: "lipo", eyes: "cctv", sservo: "servo", hservo: "servo" },
  cubesat: { battery: "lipo", eps: "pcb", obc: "rpi", comms: "radio", adcs: "chip", panels: "solar" },
};
